import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

// ENVs
import { environment } from '@environments/environment';



@Component({
  standalone: true,
  imports: [
    CommonModule
  ],
  selector: 'rental-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterSComponent {

  public version: string;
  public date: Date;

  constructor() {
    this.version = environment.VERSION;
    this.date = new Date();
  }
}
